// 该文件是专门用于创建整个应用的路由器

// 第一步引入插件(本质是一个构造函数)
import VueRouter from 'vue-router'

// 引入一下用到的组件 
import home from '../components/index'
import head from '../components/head'
import six  from '../components/sixones'
import overview from '../components/overview'
import map from '../components/map'


// 第二步创建router实例对象并暴露
export default new VueRouter({
	mode: "history",
	routes: [{
			// path是路径
			path: "/",
			//跳转的组件
			component: home,
		},
		{
			// path是路径
			path: "/head",
			//跳转的组件
			component: head,
		},
		{
			// path是路径
			path: "/six",
			//跳转的组件
			component: six,
		},
		{
			// path是路径
			path: "/overview",
			//跳转的组件
			component: overview,
		},
		{
			// path是路径
			path: "/map",
			//跳转的组件
			component: map,
		}
	]
})
// 然后去main.js中引入router实例